import React, { useState } from 'react';

import { Form, Label, LinkInputContainer, Input, ButtonsContainer, Button } from './PopoverForm';

interface LinkFormProps {
  value: string;
  onSave: (value: string) => void;
  onClose: () => void;
  label: string;
  placeholder: string;
}

export const MediaLinkForm = ({ value, label, placeholder, onSave, onClose }: LinkFormProps) => {
  const [inputValue, setInputValue] = useState(value);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onSave(inputValue);
        onClose();
      }}
      onReset={(e) => {
        e.preventDefault();
        onClose();
      }}
    >
      <Label>{label}</Label>
      <LinkInputContainer>
        <Input
          size={40}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          type="text"
          placeholder={placeholder}
        />
      </LinkInputContainer>
      <ButtonsContainer>
        <Button type="reset">Cancel</Button>
        <Button type="submit" showBorder>
          Save
        </Button>
      </ButtonsContainer>
    </Form>
  );
};
